export default {
  root: {
    borderRadius: "10px",
    // height: "48px",
  },
};
